import { RouterProvider } from "react-router";
import { router } from "./routes";

/**
 * App — the whole brochure is two static routes (Home, Pricing) rendered
 * client-side; there is no auth provider, no API client, and no theme
 * provider (the light marketing theme is fixed Tailwind tokens, not a
 * per-request niche override) because this site carries no dynamic surface.
 */
export default function App() {
  return <RouterProvider router={router} />;
}
